import { render, staticRenderFns } from "./notesCompositeRep.vue?vue&type=template&id=0928961d&"
import script from "./notesCompositeRep.vue?vue&type=script&lang=js&"
export * from "./notesCompositeRep.vue?vue&type=script&lang=js&"
import style0 from "./notesCompositeRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports